/**
 * オフィシャル TOP: バナーカルーセル（Swiper）
 * top.html / official-top.liquid の .banner-section 用
 */
(function () {
  'use strict';

  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

  /** @type {Promise<boolean> | null} */
  var swiperAssetPromise = null;

  /**
   * @returns {Promise<boolean>}
   */
  function ensureSwiperAssets() {
    if (typeof window.Swiper === 'function') {
      return Promise.resolve(true);
    }
    if (swiperAssetPromise) {
      return swiperAssetPromise;
    }

    swiperAssetPromise = new Promise(function (resolve) {
      function finish() {
        resolve(typeof window.Swiper === 'function');
      }

      try {
        if (!document.querySelector('link[data-official-top-swiper-css]')) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = SWIPER_CSS;
          link.setAttribute('data-official-top-swiper-css', '1');
          document.head.appendChild(link);
        }

        var scriptTag = document.querySelector('script[data-official-top-swiper-js]');
        if (!scriptTag) {
          scriptTag = document.createElement('script');
          scriptTag.src = SWIPER_JS;
          scriptTag.async = true;
          scriptTag.setAttribute('data-official-top-swiper-js', '1');
          scriptTag.onload = finish;
          scriptTag.onerror = finish;
          document.head.appendChild(scriptTag);
          return;
        }

        if (typeof window.Swiper === 'function') {
          finish();
          return;
        }

        scriptTag.addEventListener('load', finish);
        scriptTag.addEventListener('error', finish);
      } catch (e) {
        resolve(false);
      }
    });

    return swiperAssetPromise;
  }

  /**
   * @param {HTMLElement} section
   */
  function spaceBetweenPx(section) {
    var gapMeasure = section.querySelector('.banner-carousel-gap-measure');
    if (!gapMeasure) return 12;
    var px = gapMeasure.offsetWidth;
    return px > 0 ? px : 12;
  }

  /**
   * @param {HTMLElement} section
   */
  function initBannerSection(section) {
    if (!section || typeof window.Swiper !== 'function') return;

    var el = section.querySelector('.banner-swiper');
    if (!el) return;

    if (el.swiper && typeof el.swiper.destroy === 'function') {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {}
    }

    var prevEl = section.querySelector('.banner-swiper-button-prev');
    var nextEl = section.querySelector('.banner-swiper-button-next');
    var gap = spaceBetweenPx(section);

    var swiper;
    try {
      swiper = new window.Swiper(el, {
        loop: true,
        grabCursor: true,
        watchOverflow: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: gap,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          prevEl && nextEl
            ? {
                nextEl: nextEl,
                prevEl: prevEl,
              }
            : false,
        breakpoints: {
          750: {
            centeredSlides: false,
          },
        },
      });
    } catch (e) {
      return;
    }

    function syncBannerGap() {
      swiper.params.spaceBetween = spaceBetweenPx(section);
      swiper.update();
    }

    var rafScheduled;
    window.addEventListener('resize', function () {
      if (!section.isConnected) return;
      if (rafScheduled) return;
      rafScheduled = requestAnimationFrame(function () {
        rafScheduled = 0;
        syncBannerGap();
      });
    });

    var mqBannerLayout = window.matchMedia('(min-width: 750px)');
    mqBannerLayout.addEventListener('change', syncBannerGap);

    el.querySelectorAll('.banner-card').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        if (anchor.getAttribute('href') !== '#') return;
        e.preventDefault();
      });
    });
  }

  /**
   * @param {ParentNode | null | undefined} container
   */
  function initIn(container) {
    var root = container || document;
    if (!root.querySelectorAll) return;
    ensureSwiperAssets().then(function (ok) {
      if (!ok) return;
      root.querySelectorAll('.banner-section').forEach(function (section) {
        initBannerSection(/** @type {HTMLElement} */ (section));
      });
    });
  }

  /**
   * @param {ParentNode | null | undefined} container
   */
  function destroyIn(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('.banner-swiper').forEach(function (el) {
      if (el.swiper && typeof el.swiper.destroy === 'function') {
        try {
          el.swiper.destroy(true, true);
        } catch (e) {}
      }
    });
  }

  if (window.__officialTopBannerSwiperBound) {
    return;
  }
  window.__officialTopBannerSwiperBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initIn(document);
    });
  } else {
    initIn(document);
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initIn(/** @type {HTMLElement} */ (evt.target));
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    destroyIn(/** @type {HTMLElement} */ (evt.target));
  });
})();
